/**
 * Id the visitor (cookies, browser fingerprint, etc)
 *
 * @export
 * @returns {string}
 */
import { uuid } from "@xapp/chat-widget-core";

export function visitorFingerprint(): string {
    return uuid();
}
